module.exports = __webpack_public_path__ + "static/media/error404Top.16dc0a93.svg";